import React from 'react';
import { Space, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { TTBTableDataType } from '../../../../types/tryThenBuy';
import gvc2TmImg from '../../../../assets/images/gvc2Tm.png';
import gvcReturnImg from '../../../../assets/images/gvcReturn.png';
import tm2CustomerImg from '../../../../assets/images/tm2Customer.png';
import { mismatchReturn, mismatchWrongReturn } from '../../../../assets';
import { btnActive } from '../../../../styles';
import { TRY_THEN_BUY } from '../../../../constants/define/translation';

interface ShipmentColumnProps {
  record: TTBTableDataType;
}

export default React.memo((props: ShipmentColumnProps) => {
  const { t } = useTranslation(TRY_THEN_BUY);
  const { record } = props;
  const gvc2Tm =
    record.GVCReturnToTMTrackingNumber &&
    record.GVCReturnToTMTrackingCarrier &&
    record.GVCProductReturningToTMTrackingUrl;
  const gvcReturn =
    record.GVCReturnTrackingCarrier && record.GVCReturnTrackingNumber && record.GVCProductReturningTrackingUrl;
  const tm2Customer = record.shipmentTrackingNumber && record.shipmentCarrierName && record.shipmentTrackingUrl;
  const specMismatchedReturn =
    record?.specsMismatchedReturnTrackingNumber &&
    record?.specsMismatchedReturnTrackingCarrier &&
    record?.specsMismatchedReturnTrackingUrl;
  const specMismatchedReturnWrong =
    record?.specsMismatchedReturnWrongComponentsTrackingNumber &&
    record?.specsMismatchedReturnWrongComponentsTrackingCarrier &&
    record?.specsMismatchedReturnWrongComponentsTrackingUrl;
  return (
    <StyledContainer>
      <Space>
        {tm2Customer && (
          <Tooltip title={t('table.tooltip.shipmentTrackingUrl')}>
            <a target="_blank" rel="noreferrer" href={record.shipmentTrackingUrl}>
              <img className="trackingImg" alt={t('table.tooltip.shipmentTrackingUrl')} src={tm2CustomerImg} />
            </a>
          </Tooltip>
        )}
        {gvcReturn && (
          <Tooltip title={t('table.tooltip.returnUrl')}>
            <a target="_blank" rel="noreferrer" href={record.GVCProductReturningTrackingUrl}>
              <img className="trackingImg" alt={t('table.tooltip.returnUrl')} src={gvcReturnImg} />
            </a>
          </Tooltip>
        )}
        {gvc2Tm && (
          <Tooltip title={t('table.tooltip.returnToTMUrl')}>
            <a target="_blank" rel="noreferrer" href={record.GVCProductReturningToTMTrackingUrl}>
              <img className="trackingImg" alt={t('table.tooltip.returnToTMUrl')} src={gvc2TmImg} />
            </a>
          </Tooltip>
        )}
        {specMismatchedReturn && (
          <Tooltip title={t('table.tooltip.specMismatchReturnUrl')}>
            <a target="_blank" rel="noreferrer" href={record.specsMismatchedReturnTrackingUrl}>
              <img className="trackingImg" alt={t('table.tooltip.specMismatchReturnUrl')} src={mismatchReturn} />
            </a>
          </Tooltip>
        )}
        {specMismatchedReturnWrong && (
          <Tooltip title={t('table.tooltip.specMismatchComponentsReturnUrl')}>
            <a target="_blank" rel="noreferrer" href={record.specsMismatchedReturnWrongComponentsTrackingUrl}>
              <img
                className="trackingImg"
                alt={t('table.tooltip.specMismatchComponentsReturnUrl')}
                src={mismatchWrongReturn}
              />
            </a>
          </Tooltip>
        )}
      </Space>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.5rem;
  ${btnActive}
  & .trackingImg {
    width: 24px;
  }
`;
